import { inject, Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'

import { UserStore } from 'app/store/user.store'

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate {
  userStore = inject(UserStore)

  constructor(private router: Router) {}

  canActivate(): boolean {
    if (this.userStore.isLoggedIn()) {
      // If logged in, redirect to home.
      this.router.navigate(['/'])
      return false
    }
    return true
  }
}
